import React, { useEffect, useState } from "react";
import styles from "../profile/details.module.css";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Checkbox from "@mui/material/Checkbox";
import {
  getSingleUser,
  updateCurrentUser,
  updateUserByAdmin,
} from "../../services/user.service";
import moment from "moment";
import { uploadImage } from "../../services/upload.service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Atolls, getIslandBasedOnAtoll } from "../../services/data.service";
import Loader from "../../component/loader/Loader";
function UpdateUser() {
  const navigate = useNavigate();
  const [same, setSame] = useState(false);
  const { id } = useParams();
  const currencies = [
    {
      value: "shareHolder",
      label: "Share Holder",
    },
    {
      value: "proxy",
      label: "Proxy",
    },
  ];
  const [loader, setLoader] = useState(true);

  const [atolls, setAtolls] = useState();
  const [Islands, setIslands] = useState({
    permanent: [],
    current: [],
  });
  const [details, setDetails] = useState({
    Account_No: "",
    DOB: "",
    Email: "",
    Mobile: "",
    Name: "",
    NationalID: "",
    Type: "",
    STatus: "",
    currentStreet: "",
    currentAtoll: "",
    currentIsland: "",
    currentHouseNo: "",
    currentZip: "",
    currentCity: "",
    currentCountry: "",
    Minor: "",
    permanentStreet: "",
    permanentAtoll: "",
    permanentIsland: "",
    permanentHouseNo: "",
    permanentZip: "",
    permanentCity: "",
    permanentCountry: "",
    Parent_name: "",
    Parent_NationalID: "",
    Relation: "",
    Contact: "",
    Bank_proof: "",
    National_proof_back: "",
    National_proof_front: "",
    Comment: "",
  });

  const getUserData = () => {
    getSingleUser({ id }).then((res) => {
      if (res?.result) {
        const {
          Account_No,
          DOB,
          Email,
          Mobile,
          Name,
          NationalID,
          Type,
          Status,
          Current_address,
          Permanent_address,
          Minor,
          Bank_proof,
          National_proof_back,
          National_proof_front,
          Comment,
          Guardian_info,
        } = res?.result;

        setDetails({
          ...details,
          Account_No,
          DOB,
          Email,
          Mobile,
          Name,
          NationalID,
          Type,
          Status,
          Minor,
          Parent_name: Guardian_info?.Parent_name,
          Parent_NationalID: Guardian_info?.Parent_NationalID,
          Relation: Guardian_info?.Relation,
          Contact: JSON.stringify(Guardian_info?.Contact),
          Bank_proof,
          National_proof_back,
          National_proof_front,
          Comment,
          currentStreet: Current_address?.Street,
          currentAtoll: Current_address?.Atoll,
          currentIsland: Current_address?.Island,
          currentHouseNo: Current_address?.HouseNo,
          currentZip: Current_address?.Zip,
          currentCity: Current_address?.City,
          currentCountry: Current_address?.Country,
          permanentStreet: Permanent_address?.Street,
          permanentAtoll: Permanent_address?.Atoll,
          permanentIsland: Permanent_address?.Island,
          permanentHouseNo: Permanent_address?.HouseNo,
          permanentZip: Permanent_address?.Zip,
          permanentCity: Permanent_address?.City,
          permanentCountry: Permanent_address?.Country,
        });
        if (Current_address?.Atoll) {
          getIslandBasedOnAtoll({
            atollCode: Current_address?.Atoll,
          }).then((abs) => {
            setIslands((prev) => ({
              ...prev,
              current: abs?.result,
            }));

          });
        }
        if (Permanent_address?.Atoll) {
          getIslandBasedOnAtoll({
            atollCode: Permanent_address?.Atoll,
          }).then((abs) => {
            setIslands((prev) => ({
              ...prev,
              permanent: abs?.result,
            }));
          });
        }

        setLoader(false);
      }
    });
    Atolls().then((res) => {
      if (res?.result) {
        setAtolls(res?.result);
      }
    });
  };
  useEffect(() => {
    getUserData();
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e?.target;
    setDetails((prev) => ({ ...prev, [name]: value }));

    if (name === "currentAtoll") {
      getIslandBasedOnAtoll({ atollCode: value }).then((res) => {
        setIslands((prev) => ({
          ...prev,
          current: res?.result,
        }));
      });
    }

    if (name === "permanentAtoll") {
      getIslandBasedOnAtoll({ atollCode: value }).then((res) => {
        setIslands((prev) => ({
          ...prev,
          permanent: res?.result,
        }));
      });
    }

  };

  const handleUpdate = async () => {
    try {
      setLoader(true);
      const updatedDetails = {};
      setDetails((prevDetails) => {
        const updatedData = {
          ...prevDetails,
          ...updatedDetails,
        };
        const payload = {
          ...updatedData,
          id: id,
          Account_No: updatedData?.Account_No,
          Permanent_address: {
            Street: updatedData?.permanentStreet,
            Atoll: updatedData?.permanentAtoll,
            Island: updatedData?.permanentIsland,
            HouseNo: updatedData?.permanentHouseNo,
            Zip: updatedData?.permanentZip,
            City: updatedData?.permanentCity,
            Country: updatedData?.permanentCountry,
          },
          Current_address: {
            Street: updatedData?.currentStreet,
            Atoll: updatedData?.currentAtoll,
            Island: updatedData?.currentIsland,
            HouseNo: updatedData?.currentHouseNo,
            Zip: updatedData?.currentZip,
            City: updatedData?.currentCity,
            Country: updatedData?.currentCountry,
          },
          Guardian_info: {
            Parent_name: updatedData?.Parent_name,
            Parent_NationalID: updatedData?.Parent_NationalID,
            Relation: updatedData?.Relation,
            Contact: updatedData?.Contact !== "null" ? updatedData?.Contact : 0,
          },
        };
        updateUserByAdmin(payload).then((res) => {
          toast.success(res?.message);
          getUserData();
          setLoader(false);
        });
        return updatedData;
      });
    } catch (error) {
      console.error("Error uploading files", error);
    }
  };
  useEffect(() => {
    if (same == true) {
      setDetails({
        ...details,
        currentStreet: details?.permanentStreet,
        currentAtoll: details?.permanentAtoll,
        currentIsland: details?.permanentIsland,
        currentHouseNo: details?.permanentHouseNo,
        currentZip: details?.permanentZip,
        currentCity: details?.permanentCity,
        currentCountry: details?.permanentCountry,
      });
    }
  }, [same]);
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className={styles.container}>
          <div className={styles.main}>
            <h5>User Update</h5>

            <div className={styles.status}>
              <p>
                Status :{" "}
                <span style={{ fontSize: "14px", color: "#F9BE24" }}>
                  {details?.Status}
                </span>
              </p>
            </div>
            {details && (
              <div className={styles.profileDetails}>
                <div className={styles.personalInfo}>
                  <h3>Personal Details</h3>
                </div>
                <div className={styles.infoContainer}>
                  <div>
                    <label htmlFor="">Select Type</label>
                    <TextField
                      id="outlined-basic"
                      select
                      value={details?.Type}
                      name="Type"
                      disabled
                    // onChange={handleChange}
                    >
                      {currencies.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

                    <label htmlFor="">Name</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.Name}
                      name="Name"
                      onChange={handleChange}
                    />
                    <label htmlFor="">DOB</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={[
                          "DatePicker",
                          "MobileDatePicker",
                          "DesktopDatePicker",
                          "StaticDatePicker",
                        ]}
                      >
                        <DatePicker
                          name="DOB"
                          maxDate={dayjs()}
                          onChange={(dateObject) => {
                            // Assuming dateObject.$d is the Date object
                            const formattedDate = `${dateObject.$D}-${(
                              dateObject.$M + 1
                            )
                              .toString()
                              .padStart(2, "0")}-${dateObject.$y}`;

                            if (
                              new Date().getFullYear() - dateObject?.$y <=
                              18
                            ) {
                              setDetails({
                                ...details,
                                Minor: true,
                                DOB: formattedDate,
                              });
                            } else {
                              setDetails({
                                ...details,
                                Minor: false,
                                DOB: formattedDate,
                              });
                            }
                          }}
                          // format="DD-MM-YYYY"
                          value={dayjs(
                            moment(details?.DOB).format("YYYY-MM-DD")
                          )}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    {details?.Minor && (
                      <>
                        <label htmlFor="">Name of Guardians</label>
                        <TextField
                          id="outlined-select-currency"
                          value={details?.Parent_name}
                          name="Parent_name"
                          onChange={handleChange}
                        />
                        <label htmlFor="">Relation</label>
                        <TextField
                          id="outlined-select-currency"
                          value={details?.Relation}
                          name="Relation"
                          onChange={handleChange}
                        />
                      </>
                    )}
                    <label htmlFor="">Email</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.Email}
                      name="Email"
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="">National ID</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.NationalID}
                      name="NationalID"
                      disabled
                    // onChange={handleChange}
                    />
                    <label htmlFor="">Contact No.</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.Mobile}
                      name="Mobile"
                      onChange={handleChange}
                    />
                    <label htmlFor="">Account No.</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.Account_No}
                      name="Account_No"
                      onChange={handleChange}
                    />

                    {details?.Minor && (
                      <>
                        <label htmlFor="">Guardian's ID</label>
                        <TextField
                          id="outlined-select-currency"
                          value={details?.Parent_NationalID}
                          name="Parent_NationalID"
                          onChange={handleChange}
                        />
                        <label htmlFor="">Guardian's Contact</label>
                        <TextField
                          id="outlined-select-currency"
                          value={details?.Contact}
                          name="Contact"
                          onChange={handleChange}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className={styles.personalInfo}>
                  <h3>Address Details</h3>
                </div>
                <h3 className="m-4">Permanent Address</h3>
                <div className={styles.infoContainer}>
                  <div>
                    <label htmlFor="">Select Atoll</label>
                    <TextField
                      id="outlined-basic"
                      select
                      value={details?.permanentAtoll}
                      name="permanentAtoll"
                      onChange={handleChange}
                    >
                      {atolls?.map((el) => {
                        return (
                          <MenuItem
                            value={el?.atollName}
                            // onClick={() => {
                            //   getIslandBasedOnAtoll({
                            //     atollCode: el?.atollCode,
                            //   }).then((res) => {
                            //     setIslands({
                            //       ...Islands,
                            //       permanent: res?.result,
                            //     });
                            //   });
                            // }}
                          >
                            {el?.atollName}
                          </MenuItem>
                        );
                      })}
                    </TextField>

                    <label htmlFor="">House No.</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.permanentHouseNo}
                      name="permanentHouseNo"
                      onChange={handleChange}
                    />
                    <label htmlFor="">City</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.permanentCity}
                      name="permanentCity"
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="">Select Island</label>
                    <TextField
                      id="outlined-basic"
                      select
                      value={details?.permanentIsland}
                      name="permanentIsland"
                      onChange={handleChange}
                    >
                      {Islands?.permanent?.map((el) => {
                        return (
                          <MenuItem value={el?.islandName}>
                            {el?.islandName}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <label htmlFor="">Street Name</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.permanentStreet}
                      name="permanentStreet"
                      onChange={handleChange}
                    />
                    {/* <label htmlFor="">State/Province</label>
                <TextField id="outlined-select-currency" value={details?.perma} /> */}
                    <label htmlFor="">Postal/ZIP Code</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.permanentZip}
                      name="permanentZip"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className={styles.checkbox}>
                  <Checkbox onChange={() => setSame(!same)} />
                  <p>Same as permanent address</p>
                </div>
                <h3 className="m-4">Current Address</h3>
                <div className={styles.infoContainer}>
                  <div>
                    <label htmlFor="">Select Atoll</label>
                    <TextField
                      id="outlined-basic"
                      select
                      value={details?.currentAtoll}
                      name="currentAtoll"
                      onChange={handleChange}
                    >
                      {atolls?.map((el) => {
                        return (
                          <MenuItem
                            value={el?.atollName}
                            // onClick={() => {
                            //   getIslandBasedOnAtoll({
                            //     atollCode: el?.atollCode,
                            //   }).then((res) => {
                            //     setIslands({
                            //       ...Islands,
                            //       current: res?.result,
                            //     });
                            //   });
                            // }}
                          >
                            {el?.atollName}
                          </MenuItem>
                        );
                      })}
                    </TextField>

                    <label htmlFor="">House No.</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.currentHouseNo}
                      name="currentHouseNo"
                      onChange={handleChange}
                    />
                    <label htmlFor="">City</label>
                    <TextField
                      id="outlined-select-currency"
                      defaultValue={details?.currentCity}
                      name="currentCity"
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="">Select Island</label>
                    <TextField
                      id="outlined-basic"
                      select
                      value={details?.currentIsland}
                      name="currentIsland"
                      onChange={handleChange}
                    >
                      {Islands?.current?.map((el) => {
                        return (
                          <MenuItem value={el?.islandName}>
                            {el?.islandName}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <label htmlFor="">Street Name </label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.currentStreet}
                      name="currentStreet"
                      onChange={handleChange}
                    />
                    {/* <label htmlFor="">State/Province</label>
                <TextField id="outlined-select-currency" value={details?.perma} /> */}
                    <label htmlFor="">Postal/ZIP Code</label>
                    <TextField
                      id="outlined-select-currency"
                      value={details?.currentZip}
                      name="currentZip"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex justify-center mt-5">
                  <Button
                    variant="contained"
                    sx={{
                      background: "#22C25E",
                      margin: "auto",
                    }}
                    onClick={handleUpdate}
                  >
                    Update
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default UpdateUser;
